import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import RCTimePicker from 'rc-time-picker'
import 'styles/d3/timepicker.scss'

const FORMAT_12_HOUR = 'hh:mm A'
const FORMAT_24_HOUR = 'HH:mm'

const TimePicker = props => {
  const { onChange, use12HourFormat, value } = props
  const momentFormat = use12HourFormat ? FORMAT_12_HOUR : FORMAT_24_HOUR
  return (
    <RCTimePicker
      {...props}
      className='d3-time-picker'
      format={momentFormat}
      onChange={mom => onChange && onChange(mom)}
      placeholder='Enter time'
      position='bottom'
      focusOnOpen // TODO: turn off in touch devices
      // inputReadOnly // TODO: turn on in touch devices
      onKeyPress={evt => console.log(evt.target.value)}
      showSecond={false}
      use12Hours={use12HourFormat}
      value={value || null}
    />
  )
}

TimePicker.propTypes = {
  onChange: PropTypes.func,
  use12HourFormat: PropTypes.bool,
  value: PropTypes.instanceOf(moment),
}

export default TimePicker



// WEBPACK FOOTER //
// ./src/components/TimePicker.js